import { call } from 'redux-saga/effects'

export const safelyExecuteSync = <T>(fn: () => T, fallback?: T | (() => T)): T => {
  try {
    return fn()
  } catch {
    return 'function' === typeof fallback ? (fallback as () => T)() : fallback
  }
}

export const tryCatchSync =
  <Args extends unknown[], R>(fn: (...args: Args) => R, catchFn?: (exception: unknown) => R, fallback?: R) =>
  (...args: Args): R => {
    try {
      return fn(...args)
    } catch (error) {
      if (!catchFn) {
        // debugger
        return fallback // fallback can be undefined if not provided
      }
      return catchFn(error) ?? fallback
    }
  }

export const tryCatchAsync =
  <Args extends unknown[], R>(
    fn: (...args: Args) => Promise<R>,
    catchFn?: (exception: unknown) => Promise<R> | R,
    fallback?: R
  ) =>
  async (...args: Args): Promise<R> => {
    try {
      return await fn(...args)
    } catch (error) {
      if (!catchFn) {
        // debugger
        return fallback // fallback can be undefined
      }
      return (await catchFn(error)) ?? fallback
    }
  }

export const safelyAwait = async <R>(promise: Promise<R>): Promise<[null, Awaited<R>] | [Error]> => {
  try {
    return [null, await promise]
  } catch (error) {
    return [error as Error]
  }
}

export const safelyExecuteAsync =
  <Args extends unknown[], R>(fn: (...args: Args) => Promise<R> | R) =>
  async (...args: Args): Promise<[null, Awaited<R>] | [Error]> => {
    try {
      return [null, await fn(...args)]
    } catch (error) {
      return [error as Error]
    }
  }

export function* safelyExecuteSaga<Args extends unknown[], Yield, Return, Next>(
  genFn: (...args: Args) => Generator<Yield, Return, Next>,
  ...args: Args
) {
  try {
    return [null, (yield call(genFn, ...args)) as unknown as Return]
  } catch (error) {
    return [error as Error]
  }
}
